export const SearchContentCategories = [
    { value: 'lesson', label: 'レッスン' },
    { value: 'series', label: 'シリーズ' },
    { value: 'playlist', label: 'プレイリスト' },
];
export const SEARCH_FILTERS = [
    { key: 'style', label: '🧩 ジャンル' },
    { key: 'duration', label: '⏳ 時間' },
    { key: 'difficulty', label: '🔥 難易度' },
    { key: 'tag', label: '🦵 部位' },
    { key: 'trainer', label: '🎤 インストラクター' },
    { key: 'program', label: '🗂️ プログラム' },
];
export const selectedFilterCount = (filters, key) => {
    if (key === 'style')
        return filters.styleIDs.length;
    if (key === 'duration')
        return filters.durationIDs.length;
    if (key === 'difficulty')
        return filters.difficultyIDs.length;
    if (key === 'tag')
        return filters.tagIDs.length;
    if (key === 'trainer')
        return filters.trainerIDs.length;
    return 1;
};
export const hasAnyFilter = (filters) => SEARCH_FILTERS.some(({ key }) => selectedFilterCount(filters, key) > 0);
